exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rating {\r\n  unicode-bidi: bidi-override;\r\n  direction: rtl;\r\n  width: 8em;\r\n}\r\n\r\n.rating input {\r\n  position: absolute;\r\n  left: -999999px;\r\n}\r\n\r\n.rating label {\r\n  display: inline-block;\r\n  font-size: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.rating > label:before {\r\n  position: relative;\r\n  font: 1.5rem/1 FontAwesome;\r\n  display: block;\r\n  content: \"\\F005\";\r\n  color: #ccc;\r\n  background: -webkit-linear-gradient(-45deg, #d9d9d9 0%, #b3b3b3 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  margin-top: 0.4rem;\r\n}\r\n\r\n.rating > label:hover:before,\r\n.rating > label:hover ~ label:before,\r\n.rating > label.selected:before,\r\n.rating > label.selected ~ label:before {\r\n  color: #f0ad4e;\r\n  background: -webkit-linear-gradient(-45deg, #fcb551 0%, #d69a45 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n}\r\n\r\n.align-left {\r\n  text-align: left;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/form-section/label-star-rating/label-star-rating.component.css
// module id = ../../../../../src/app/widgets/form-section/label-star-rating/label-star-rating.component.css
// module chunks = main